import React from "react";
import styled from "styled-components";
import Stars from "../Scomp/Stars";
import Price from "../Scomp/Price";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

import { Link } from "react-router-dom";
import Stand from '../../assets/stand1.png'
import StandArayeshi from '../../assets/arayeshi-stand.png'
import StandPoushak from '../../assets/poushak-stand.png'
import GoodCartHomeV2Main from "./GoodCartHomeV2Main";
import GoodCartInfoHomeV2Main from "./GoodCartInfoHomeV2Main ";

const Style = styled.div`
  position: relative;
  /* padding: 0.5rem; */
  display: flex;
  .arrow{
    cursor: pointer;
    padding: 2rem 0.5rem;
    position: absolute;
    border-radius: var(--border-radius-9);
    background-color: var(--body-2);
    border: var(--border-style-2);
    top: calc(40% - 1rem);
    &.right {
      right: -1rem;
    }
    &.left {
      left:  -1rem;
    }
  }
  .selected-goods {
    position: relative;
    width: 100% ;
    .view{
      width: 100%;
      height: 100%;
    }
    .body {
        width: 100%;
        overflow: auto;
        padding: 0.5rem 0 1rem;
      ::-webkit-scrollbar {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
        display: none;  /* Safari and Chrome */
      }
      .movable {
        position: relative;
        display: flex;
        gap: 20px;
       
    }
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
@media screen and (max-width: 850px){
  padding: 0;
  .arrow{
    display:none;
  }
  .movable{
    :first-child{
      margin-right: 1rem;
    }
    :last-child{
      margin-left: 1rem;
    }
  }
  
}
  
`;


class Carousel22 extends React.Component {
  constructor(props) {
    super(props);
    this.refScroll = React.createRef();
    this.sizeGood = React.createRef();
    const isScrollable = true;
    this.state = {
      sorting: "",
      gr: "",
      subgr: "",
      goods: this.props.objects,
      lenghth:'',
      goodData: {
        G_BR_CODE: "",
        G_COL_CODE: "",
        CO_CODE: "",
        G_NAME: "",
        Price: "",
      },
      moreData:{
        imagename:'good-stand',
        imagesrc: Stand
      }
    };
  }


  makeObject = () => {
    let goods = this.props.objects.map((value, index) => {
      let stand = this.state.moreData.imagesrc
      // if(value.G_GR_CODE === 7){
      //   stand = StandArayeshi
      // }else if(value.G_GR_CODE === 3){
      //   stand = StandPoushak
      // }
      if(value.G_CODE){
        return <GoodCartInfoHomeV2Main data={value} key={index} moredata={this.state.moreData} standimg={stand} />
      }
      return
    })
    return goods
  };

  makeObjectMo=()=>{
    let goods = this.props.objects.map((value, index) => {
      return (
          <Link to={{pathname: encodeURI('/good/'+ value.G_CODE+'/' + value.G_URL+'/')}} className="cartMo" key={index}>
            <div className="imageMo" key='1'>
              <img className="imgMo" src={process.env.REACT_APP_API + '/images/goods_images/202.png'} alt={value.G_NAME} />
            </div>
            <div className="gooddtMo ">
              <span className='nameMo'> {value.G_NAME} </span>
              <Stars star={value.avg}/>
              <span className='shopMo'>نام فروشگاه:  {value.SH_NAME} </span>
            </div>
            <span className="dv"> </span>
            <div className="gooddtMo">
              <Price min={value.Min} max={value.Max} />
            </div>
          </Link>
      )
    })
    return goods;
  }
  moveRight = () => {
    let jump = this.refScroll.current.offsetWidth;
    let carousel = this.refScroll.current;
    carousel.scrollTo({
      left: carousel.scrollLeft + jump,
      behavior: "smooth",
    });

  };
  moveLeft = () => {
    let jump = this.widthScroll.current.offsetWidth;
    let carousel = this.widthScroll.current;
    carousel.scrollTo({
      left: carousel.scrollLeft - jump,
      behavior: "smooth",
    });
  };
  lenghtSize = () => {
    if (window.innerWidth > 1026) {
      return  33.3;
    } else if(window.innerWidth > 850) {
      return 34;
    }else  {
      return 30;
    }
  };
  render() {
    let width = ""
    if(window.innerWidth < 850 || this.refScroll) {
        width = ((this.props.objects.length * 275) + ((this.props.objects.length - 1) * 20)) + "px";
    }
    if(window.innerWidth > 850){
        width = ((this.props.objects.length * 275) + ((this.props.objects.length - 1) * 20)) + "px";
    }
    return (
      <Style >
        <div className="selected-goods">
          <div className="body view" id="carousel-goods" ref={this.refScroll}>
            <div
              className="movable"
              style={{width: width}}
            >
              {this.makeObject()}
            </div>
          </div>
        </div>
        {
          window.innerWidth > 850 && (this.props.objects.length > 4) ?
            <div className=" right arrow" onClick={() => {
                  if(this.refScroll.current){
                    this.refScroll.current.scrollTo({
                          left: this.refScroll.current.scrollLeft + this.refScroll.current.clientWidth,
                          behavior: 'smooth',
                      })
                  }
              }}
            >
              <ChevronRight className="icon"/>
            </div>
          : ''
        }
        {
          window.innerWidth > 850 && (this.props.objects.length > 4) ?
            <div className=" left arrow" onClick={() => {
                if(this.refScroll.current && this.sizeGood.current){

                    this.refScroll.current.scrollTo({
                        left: this.refScroll.current.scrollLeft - this.refScroll.current.clientWidth,
                        behavior: 'smooth',
                    })
                }
            }}>
              <ChevronLeft className="icon"/>
            </div>
          :''
        }
      </Style>
    );
  }
}
export default Carousel22;
